import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';
import { PayloadAction } from '@reduxjs/toolkit';

import AdminGateway from '~apis/admin';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { TEditRoleDetailsReduxParams } from '~types/feat/admin';

import { ErrorMessages, SuccessMessages } from '~utils/constants';

export default function* watchEditRoleDetails(api: AdminGateway): SagaWatcherReturnType {
    yield takeEvery('admin/adminEditRoleDetailsAttempt', handleEditRoleDetails, api);
}

function* handleEditRoleDetails(api: AdminGateway, data: PayloadAction<TEditRoleDetailsReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        roleId,
        roleName,
        access,
        status,
        allBranchAccess,
    } = data.payload;

    const response = yield* call([api, api.editRoleDetails], {
        authToken,
        roleId,
        roleName,
        access,
        status,
        allBranchAccess,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.adminEditRoleDetailsFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.adminGetRoleListingAttempt());
        yield put(combinedActions.adminEditRoleDetailsSuccess());
        yield put(combinedActions.adminSetRoleDetailsModalIsOpen(false));

        toast.success(SuccessMessages.AdminEditRoleDetailsSuccess);
    }
}
